export default function zeroPad(input: number, length: number = 2): string {
  const s = input.toString();
  const numPad = length - s.length;
  if (input < 0 || numPad <= 0) return s;

  const pad = '0'.repeat(numPad);
  return `${pad}${s}`;
}
